import React, { useState } from "react";
import { format } from "date-fns";
import { DATE_FORMAT } from "../consts";
import DocumentSliderModal from "./DocumentSliderModal";
import { Accordion } from "react-bootstrap";
import ViewMoreLess from "../reusableComponents/ViewMoreLess";

function FlagClaimsAccordion({ rows = [], formatDocumentDetails }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDocumentClick = (docs) => {
    const normalizedDocs = formatDocumentDetails ? formatDocumentDetails(docs) : docs;
    setSelectedDocs(normalizedDocs || []);
    setCurrentIndex(0);
    setShowModal(true);
  };

  if (!rows || rows.length === 0) {
    return null; // or render a <NoDataFound text="No data Found" /> if needed
  }

  return (
    <div>
      {rows.map((row, idx) => (
        <Accordion className="mb-2 p-0" key={row.id || idx}>
          <Accordion.Item className="mx-3 border_dark" eventKey={`${idx}`}>
            <Accordion.Header>
              <div className="gis-idCalc">
                {row.activityName ? row.activityName : `Activity - ${rows.length - idx}`}
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="mb-3">
                <span className="fw-bold d-block">Remarks</span>
                <span className="d-block">
                  <ViewMoreLess text={row.remarks || "--"} customClassName="w-100 mb-0 text-wrap d-inline me-2"/>
                </span>
              </div>
              <div className="mb-3">
                <span className="fw-bold d-block">Actioned Date &amp; Time</span>
                <span className="d-block">
                  {row.createdDate
                    ? format(new Date(row.createdDate), DATE_FORMAT.DD_MM_YYYY_HH_MM)
                    : "--"}
                </span>
              </div>
              <div className="mb-3">
                <span className="fw-bold d-block">Actioned By</span>
                <span className="d-block">
                  {row.createdBy || "--"}
                </span>
              </div>
              <div className="mb-1">
                <span className="fw-bold d-block">Documents</span>
                <span className="d-block">
                  {row.documents && row.documents.length > 0 ? (
                    <button
                      className="btn btn-link text-primary p-0"
                      onClick={() => handleDocumentClick(row.documents)}
                    >
                      View Documents ({row.documents.length})
                    </button>
                  ) : (
                    <span className="text-muted">---</span>
                  )}
                </span>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ))}
      {showModal && (
        <DocumentSliderModal
          show={showModal}
          onClose={() => setShowModal(false)}
          documents={selectedDocs}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
        />
      )}
    </div>
  );
}

export default FlagClaimsAccordion;